// components/SquareCardForm.jsx
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

const SquareCardForm = ({ customerId, token, onSuccess }) => {
  const cardRef = useRef(null);
  const cardInstance = useRef(null);
  const [loading, setLoading] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const loadSquare = async () => {
      try {
        console.log("📦 Loading Square SDK...");

        if (!window.Square) {
          console.error("❌ Square.js not loaded");
          return;
        }

        const payments = await window.Square.payments(
          "sq0idp-6vCy53QKHi4rcaAospWdAA", // Production App ID
          "LFMJY4ZAT8NHH" // Location ID
        );

        const card = await payments.card();
        await card.attach(cardRef.current);
        cardInstance.current = card;
        console.log("✅ Square card instance attached");
        setReady(true);
      } catch (err) {
        console.error("❌ Failed to load Square SDK:", err);
      }
    };

    loadSquare();

    return () => {
      if (cardRef.current) {
        cardRef.current.innerHTML = "";
      }
      cardInstance.current = null;
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); // 🔒 Prevent form reload
    console.log("🟢 Submit button clicked");

    if (!cardInstance.current) {
      console.error("❌ Card instance not ready");
      return;
    }

    setLoading(true);

    try {
      const result = await cardInstance.current.tokenize();
      console.log("💳 Tokenize result:", result);
      if (result.status !== "OK") throw new Error("Tokenization failed");

      const cardNonce = result.token;
      console.log("🔐 Tokenized Card Nonce:", cardNonce);
      console.log("📤 Sending to backend:", { customerId, token });

      await axios.post("https://ironglassbyte.com:5000/payments/store-card", {
        cardNonce,
        customerId,
        token,
      });

      onSuccess?.();
    } catch (err) {
      console.error("❌ Failed to save card:", err);
      alert("Failed to save card. Please try again.");
    }

    setLoading(false);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-md mx-auto p-4 bg-black rounded shadow"
      autoComplete="off"
    >
      <h2 className="text-xl font-semibold mb-3 text-gray-500">
        Enter Card Details
      </h2>
      <div
        ref={cardRef}
        className="border text-stone-200 p-3 rounded mb-4"
        id="card-container"
      />
      <button
        type="button" // ← change from "submit" to "button"
        disabled={!ready || loading}
        onClick={handleSubmit} // ← manually trigger
        className="w-full py-2 px-4 bg-green-600 text-white font-bold rounded hover:bg-green-700"
      >
        {loading ? "Saving..." : "Save Card & Subscribe"}
      </button>
    </form>
  );
};

export default SquareCardForm;
